import React from 'react';
import AchievementMetrics from './AchievementMetrics';
import { isDailyHabitsList } from '../constants/listTypes';

export default function RightPanel({ activeList }) {
  // Only show panel for special lists that need it (like Daily Habits)
  const isDailyHabits = activeList && isDailyHabitsList(activeList.list_type);
  
  // Don't render the panel at all if there's nothing to show
  if (!isDailyHabits) {
    return null;
  }

  return (
    <div className="right-panel">
      <AchievementMetrics 
        listId={activeList.id} 
        listType={activeList.list_type}
        onRefresh={() => {
          // Metrics will auto-refresh when list changes
        }}
      />
    </div>
  );
}

